import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import Select from "react-select";

const AddAsset = () => {
  const [form, setForm] = useState({
    category_id: "",
    subcategory_id: "",
    company_asset_code: "",
    serial_number: "",
    type_id: "",
    asset_name: "",
    department_id: "",
    location_id: "",
    manufature_id: "",
    supplier_id: "",
    outsource_id: "",
    helpdesk_id: "",
    purchase_date: "",
    manufacture_date: "",
    invoice_no: "",
    unit_price: "",
    licence_id: "",
    licence_date: "",
    service_date: "",
    warranty_end_date: "",
    is_medical: "0",
    status_id: "",
    asset_note: "",
  });
const history = useHistory();

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [assetTypes, setAssetTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [outsourceList, setOutsourceList] = useState([]);
  const [helpdesks, setHelpdesks] = useState([]);
  const [licences, setLicences] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const [assetImage, setAssetImage] = useState(null);
  const [licenseFile, setLicenseFile] = useState(null);

  // ----------------------------------------------------
  // Handle input change
  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ----------------------------------------------------
  // Load initial form data
  useEffect(() => {
    loadFormData();
  }, []);

  const loadFormData = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/form-data", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const d = res.data;

      setCategories(d.categories);
      setAssetTypes(d.assetTypes);
      setDepartments(d.departments);
      setManufacturers(d.manufacturers);
      setOutsourceList(d.outsource);
      setHelpdesks(d.helpdesks);
      setLicences(d.licences);
      setStatusList(d.status);
    } catch (err) {
      toast.error("Failed to load form data");
    }
  };

  // ----------------------------------------------------
  // Load dynamic subcategories + asset code
  const loadSubcategories = async (categoryId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/subcategories1/${categoryId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
      });

      const data = res.data.data; // { subcategories, asset_code }

      setSubcategories(
        Array.isArray(data.subcategories) ? data.subcategories : []
      );

      setForm((prev) => ({
        ...prev,
        company_asset_code: data.asset_code || "",
        category_id: categoryId,
      }));
    } catch (err) {
      setSubcategories([]);
    }
  };

  // ----------------------------------------------------
  // Load dynamic locations
  const loadLocations = async (deptId) => {
    try {
      const res = await axios.get(API_BASE_URL + `/locations/${deptId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const locs = res.data.data; // { status, data: [...] }
      setLocations(Array.isArray(locs) ? locs : []);
    } catch {
      setLocations([]);
    }
  };

  // ----------------------------------------------------
  // Load suppliers
  const loadSuppliers = async (mfgId) => {
    try {
      const res = await axios.get(API_BASE_URL + `/suppliers/${mfgId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const supps = res.data.data; // { status, data: [...] }
      setSuppliers(Array.isArray(supps) ? supps : []);
    } catch {
      setSuppliers([]);
    }
  };

  // ----------------------------------------------------
  // Save Asset
  const handleSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    Object.entries(form).forEach(([key, val]) => fd.append(key, val));

    if (assetImage) fd.append("asset_image", assetImage);
    if (licenseFile) fd.append("licensefile", licenseFile);

    try {
      await axios.post(API_BASE_URL + "/add", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

toast.success("Asset added successfully!");
      setTimeout(() => {
      history.push("/asset-list");   // <-- v5 redirect
    }, 1500);

    } catch (err) {

  if (err.response && err.response.status === 422) {
    const errors = err.response.data.errors;

    // Show all Laravel validation errors
    Object.values(errors).forEach(msg => {
      toast.error(msg[0]);
    });

    return;
  }

  toast.error("Error submitting asset");
 
}
  };

  // ----------------------------------------------------
  return (
    <div className="container mt-4">
     <ToastContainer position="bottom-right" />

      <div className="card shadow-sm">
        <div className="card-header">
          <h5 className="mb-0">New Asset</h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {/* Asset Information */}
            <fieldset className="border p-3">
              <legend className="w-auto px-2">Asset Information</legend>

              <div className="row g-3">
                {/* Category */}
               <div className="col-md-4 ">
  <label className="form-label">
    Category 
  </label>

  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
    options={categories.map((c) => ({
      value: c.assets_category_id,
      label: c.category_name,
    }))}

    value={
      categories
        .map((c) => ({
          value: c.assets_category_id,
          label: c.category_name,
        }))
        .find((opt) => opt.value === form.category_id) || null
    }

    onChange={(selected) => {
      const id = selected ? selected.value : "";
      setForm((prev) => ({ ...prev, category_id: id }));

      if (id) {
        loadSubcategories(id);
      } else {
        setSubcategories([]);
        setForm((prev) => ({ ...prev, company_asset_code: "" }));
      }
    }}

    placeholder="Search category..."
    className="form-control p-0"
  />
</div>

                {/* Subcategory */}
               <div className="col-md-4">
  <label className="form-label">Sub Category</label>

  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
    options={subcategories?.map((s) => ({
      value: s.assets_subcategory_id,
      label: s.category_name,
    }))}

    value={
      subcategories
        ?.map((s) => ({
          value: s.assets_subcategory_id,
          label: s.category_name,
        }))
        .find((opt) => opt.value === form.subcategory_id) || null
    }

    onChange={(selected) => {
      const id = selected ? selected.value : "";
      setForm((prev) => ({ ...prev, subcategory_id: id }));
    }}

    placeholder="Search subcategory..."
    className="form-control p-0"
  />
</div>

                {/* Company Asset Code (disabled) */}
                <div className="col-md-4">
                  <label className="form-label">Company Asset Code</label>
                  <input
                    type="text"
                    className="form-control"  style={{ height: "38px", border: "1px solid #ced4da" }}

                    value={form.company_asset_code}
                    disabled
                  />
                  <input
                    type="hidden"
                    name="company_asset_code"
                    value={form.company_asset_code}
                  />
                </div>

                {/* Serial Number */}
                <div className="col-md-4">
                  <label className="form-label">Serial No </label>
                  <input
                    type="text"
                    className="form-control  required-input required-tooltip"style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="serial_number"
                    onChange={handleInput}
                  />
                </div>

                {/* Asset Type */}
                <div className="col-md-4">
                  <label className="form-label">Asset Type </label>
                 <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
  options={assetTypes.map((t) => ({
    value: t.type_id,
    label: t.type_name,
  }))}

  value={
    assetTypes
      .map((t) => ({ value: t.type_id, label: t.type_name }))
      .find((opt) => opt.value === form.type_id) || null
  }

  onChange={(selected) =>
    setForm((prev) => ({ ...prev, type_id: selected?.value || "" }))
  }

  placeholder="Search asset type..."
  className="form-control p-0"
/>

                </div>
              </div>
            </fieldset>

            {/* Location Information */}
            <fieldset className="border p-3 mt-3">
              <legend className="w-auto px-2">Location Information</legend>

              <div className="row g-3 ">
                <div className="col-md-4 required-tooltip ">
  <label>Asset Name </label>
                 <input
  type="text"
  className="form-control required-input required-tooltip"
 style={{ height: "38px", border: "1px solid #ced4da" }}

  name="asset_name"
  onChange={handleInput}
/>

                </div>

              <div className="col-md-4">
  <label>Department </label>

  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
    options={departments.map((d) => ({
      value: d.department_id,
      label: d.department_name,
    }))}

    value={
      departments
        .map((d) => ({
          value: d.department_id,
          label: d.department_name,
        }))
        .find((opt) => opt.value === form.department_id) || null
    }

    onChange={(selected) => {
      const id = selected ? selected.value : "";
      setForm((prev) => ({ ...prev, department_id: id }));

      if (id) {
        loadLocations(id);   // ⬅ SAME LOGIC
      } else {
        setLocations([]);
      }
    }}

    placeholder="Search department..."
    className="form-control p-0"
  />
</div>

                <div className="col-md-4">
                  <label>Location </label>
                 <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
  options={locations.map((l) => ({
    value: l.id,
    label: l.location_name,
  }))}

  value={
    locations
      .map((l) => ({ value: l.id, label: l.location_name }))
      .find((opt) => opt.value === form.location_id) || null
  }

  onChange={(selected) =>
    setForm((prev) => ({ ...prev, location_id: selected?.value || "" }))
  }

  placeholder="Search location..."
  className="form-control p-0"
/>


                </div>
              </div>
            </fieldset>

            {/* Supplier & Manufacturer */}
            <fieldset className="border p-3 mt-3">
              <legend className="w-auto px-2">Supplier & Manufacturer</legend>

              <div className="row g-3">
                {/* Manufacturer */}
                <div className="col-md-4">
  <label>Manufacturer </label>

  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
    options={manufacturers.map((m) => ({
      value: m.manufacturer_id,
      label: m.manufacturer_name,
    }))}

    value={
      manufacturers
        .map((m) => ({
          value: m.manufacturer_id,
          label: m.manufacturer_name,
        }))
        .find((opt) => opt.value === form.manufature_id) || null
    }

    onChange={(selected) => {
      const id = selected ? selected.value : "";

      setForm((prev) => ({ ...prev, manufature_id: id }));

      if (id) {
        loadSuppliers(id);  // ⬅ SAME LOGIC
      } else {
        setSuppliers([]);
      }
    }}

    placeholder="Search manufacturer..."
    className="form-control p-0"
/>
</div>


                {/* Supplier */}
                <div className="col-md-4">
                  <label>Supplier</label>
                 <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
  options={suppliers.map((s) => ({
    value: s.supplier_id,
    label: s.supplier_name,
  }))}

  value={
    suppliers
      .map((s) => ({ value: s.supplier_id, label: s.supplier_name }))
      .find((opt) => opt.value === form.supplier_id) || null
  }

  onChange={(selected) =>
    setForm((prev) => ({ ...prev, supplier_id: selected?.value || "" }))
  }

  placeholder="Search supplier..."
  className="form-control p-0"
/>

                </div>

                {/* Outsource */}
                <div className="col-md-4">
                  <label>Outsource / Service</label>
                 <Select
  options={outsourceList.map((o) => ({
    value: o.outsource_id,
    label: o.outsource_name,
  }))}

  value={
    outsourceList
      .map((o) => ({ value: o.outsource_id, label: o.outsource_name }))
      .find((opt) => opt.value === form.outsource_id) || null
  }

  onChange={(selected) =>
    setForm((prev) => ({ ...prev, outsource_id: selected?.value || "" }))
  }

  placeholder="Search outsource..."
  className="form-control p-0"
/>

                </div>

                {/* Helpdesk */}
                <div className="col-md-4">
                  <label>Helpdesk </label>
                  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
  options={helpdesks.map((h) => ({
    value: h.department_id,
    label: h.department_name,
  }))}

  value={
    helpdesks
      .map((h) => ({ value: h.department_id, label: h.department_name }))
      .find((opt) => opt.value === form.helpdesk_id) || null
  }

  onChange={(selected) =>
    setForm((prev) => ({ ...prev, helpdesk_id: selected?.value || "" }))
  }

  placeholder="Search helpdesk..."
  className="form-control p-0"
/>

                </div>
              </div>
            </fieldset>

            {/* Price Information */}
            <fieldset className="border p-3 mt-3">
              <legend className="w-auto px-2">Price Information</legend>

              <div className="row g-3">
                <div className="col-md-4">
                  <label>Purchase Date</label>
                  <input
                    type="date"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="purchase_date"
                    onChange={handleInput}
                  />
                </div>

                <div className="col-md-4">
                  <label>Manufacture Date</label>
                  <input
                    type="date"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="manufacture_date"
                    onChange={handleInput}
                  />
                </div>

                <div className="col-md-4">
                  <label>Invoice Number</label>
                  <input
                    type="text"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="invoice_no"
                    onChange={handleInput}
                  />
                </div>

                <div className="col-md-4">
                  <label>Unit Price </label>
                  <input
                    type="text"
                    className="form-control required-input" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="unit_price"
                    onChange={handleInput}
                  />
                </div>
              </div>
            </fieldset>

            {/* License Information */}
            <fieldset className="border p-3 mt-3">
              <legend className="w-auto px-2">License Information</legend>

              <div className="row g-3">
                <div className="col-md-4">
                  <label>License</label>
                 <Select
  options={licences.map((l) => ({
    value: l.licence_id,
    label: l.licence_title,
  }))}

  value={
    licences
      .map((l) => ({ value: l.licence_id, label: l.licence_title }))
      .find((opt) => opt.value === form.licence_id) || null
  }

  onChange={(selected) =>
    setForm((prev) => ({ ...prev, licence_id: selected?.value || "" }))
  }

  placeholder="Search licence..."
  className="form-control p-0"
/>

                </div>

                <div className="col-md-4">
                  <label>License Expiry</label>
                  <input
                    type="date"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="licence_date"
                    onChange={handleInput}
                  />
                </div>

                <div className="col-md-4">
                  <label>Service Date</label>
                  <input
                    type="date"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="service_date"
                    onChange={handleInput}
                  />
                </div>

                <div className="col-md-4">
                  <label>Warranty End Date</label>
                  <input
                    type="date"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="warranty_end_date"
                    onChange={handleInput}
                  />
                </div>

                <div className="col-md-4">
                  <label>License File</label>
                  <input
                    type="file"
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    onChange={(e) => setLicenseFile(e.target.files[0])}
                  />
                </div>
              </div>
            </fieldset>

            {/* Status & Image */}
            <fieldset className="border p-3 mt-3">
              <legend className="w-auto px-2">Status & Conditions</legend>

              <div className="row g-3">
                <div className="col-md-4">
  <label>Status</label>

  <Select
    options={statusList.map((st) => ({
      value: st.status_id,
      label: st.status_name,
    }))}

    value={
      statusList
        .map((st) => ({
          value: st.status_id,
          label: st.status_name,
        }))
        .find((opt) => opt.value === form.status_id) || null
    }

    onChange={(selected) => {
      setForm((prev) => ({
        ...prev,
        status_id: selected ? selected.value : "",
      }));
    }}

    placeholder="Search status..."
    className="form-control p-0"
/>
</div>


                <div className="col-md-4">
                  <label>Medical Equipment?</label>
                  <select
                    className="form-control" style={{ height: "38px", border: "1px solid #ced4da" }}

                    name="is_medical"
                    value={form.is_medical}
                    onChange={handleInput}
                  >
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <label>Asset Image</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setAssetImage(e.target.files[0])}
                  />
                </div>

                <div className="col-md-12 required-tooltip">
                  <label>Asset Note </label>
                  <textarea
                    className="form-control required-input required-tooltip"
                    rows="3"
                    name="asset_note"
                    onChange={handleInput}
                  ></textarea>
                </div>
              </div>
            </fieldset>

            <button type="submit" className="btn btn-primary mt-4">
              Save Asset
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddAsset;
